export default __webpack_public_path__ + "static/media/020-chemistry.abc39c15.png";